import React from 'react';
const Reports: React.FC = () => <div>Reports</div>;
export default Reports;